/**
 * Send Chat Gift UseCase
 *
 * Chat-gift variant: media-less transaction with `chatInfo`, null
 * notification and a computed `groupChatId`. Mirrors the content path
 * (SendContentGiftUseCase) otherwise. Validates inputs, delegates to
 * GiftService and refreshes the local wallet on success.
 *
 * Flutter source: chat_screen.dart:3642-3673 + send_gift_bottom_sheet.dart:159-223
 */
import type { SendChatGiftInput } from '@/domain/input/gift/sendChatGiftInput';
import type { GiftService } from '@/domain/services/gift/giftService';
import { RefreshWalletUseCase } from '@/domain/usecases/wallet/refreshWalletUseCase';

export class SendChatGiftUseCase {
  constructor(
    private readonly giftService: GiftService,
    private readonly refreshWalletUseCase: RefreshWalletUseCase = new RefreshWalletUseCase(),
  ) {}

  async execute(input: SendChatGiftInput): Promise<boolean> {
    if (input.instances <= 0) return false;

    const success = await this.giftService.executeSendChatGift(input);

    if (success) {
      this.refreshWalletUseCase.execute();
    }

    return success;
  }
}
